<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'client-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.cnpj | prCnpj }}
          </td>
          <td>
            {{ props.item.active ? "Ativo" : "Inativo" }}
          </td>
          <td class="text-xs-center">
            <v-tooltip top>
              <v-btn :color="props.item.active ? 'success' : 'dark'" flat icon slot="activator" @click="toggleStatus({ id: props.item.id })">
                <v-icon v-if="props.item.active">toggle_on</v-icon>
                <v-icon v-else>toggle_off</v-icon>
              </v-btn>
              <span>{{ props.item.active ? "Desativar" : "Ativar" }}</span>
            </v-tooltip>

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'client-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      active: false,
      headers: [
        {
          text: this.$t('attributes.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.client.cnpj'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.client.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = ClientService;
      this.routerName = 'client';
    },
    async toggleStatus({ id }) {
      await ClientService.toggleStatus({ id });
      this.search(this.paginator.currentPage);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/client/ClientList.vue